// @flow
import React, { Component } from 'react';

export const ESCAPE_KEYCODE: number = 27;

type Props = {
  handleClose: Function,
};

export default function withEscapeToDismiss() {
  return (DecoratedComponent: Object) => class extends Component {
    constructor(props: Props) {
      super(props);
      this.onEscapePressed = this.onEscapePressed.bind(this);
    }

    componentDidMount() {
      window.addEventListener('keydown', this.onEscapePressed, false);
    }

    componentWillUnmount() {
      window.removeEventListener('keydown', this.onEscapePressed, false);
    }

    onEscapePressed(event: Object) {
      if (event.keyCode === ESCAPE_KEYCODE) {
        this.props.handleClose();
      }
    }

    onEscapePressed: Function;

    render() {
      return (
        <DecoratedComponent {...this.props} />
      );
    }
    };
}



/** WEBPACK FOOTER **
 ** ./src/js/components/others/WithEscapeToDismiss.jsx
 **/